import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Space } from 'antd';
import { BaseModal } from '@/components/Settings/DataExtraction/Modals/shared/BaseModal';
import { GhostButton, PrimaryButton } from '@/components/ui/Button';
import { Text } from '@/components/Typography';
import { DeleteOutlinedBig } from '../styles';

interface DeleteDataExtractionModalProps {
	visible?: boolean;
	loading?: boolean;
	onConfirm: () => void;
	onCancel: () => void;
	customMessage?: React.ReactNode;
}

export function DeleteDataExtractionModal({
	visible = false,
	loading = false,
	customMessage,
	onConfirm,
	onCancel
}: Readonly<DeleteDataExtractionModalProps>) {
	return (
		<BaseModal visible={visible} onCancel={onCancel} footer={false}>
			<Space direction="vertical" size={24} align="center" style={{ width: '100%' }}>
				<DeleteOutlinedBig />
				<Text>{customMessage}</Text>
				<Row justify="center" gutter={16}>
					<Col>
						<GhostButton key="cancel" onClick={onCancel} disabled={loading}>
							{I18n.get('Cancel')}
						</GhostButton>
					</Col>
					<Col>
						<PrimaryButton type="primary" onClick={onConfirm} loading={loading}>
							{I18n.get('Yes')}
						</PrimaryButton>
					</Col>
				</Row>
			</Space>
		</BaseModal>
	);
}
